import type { GetStaticProps } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import MobilePageHeader from "@/components/Mobile/Header/PageTitle";
import PcProductsList from "@/components/Mall/ProductsList";
import MobileProductList from "@/components/Mobile/Mall/ProductList";

// Product list page
const ProductListPage = () => {
  return (
    <>
      <MobilePageHeader title="menu.product_category" />
      <PcProductsList />
      <MobileProductList />
    </>
  );
};

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale ?? "sc", [
        process.env.NEXT_PUBLIC_MTS_NS || "",
      ])),
    },
  };
};

export default ProductListPage;
